import { aPackagePickerEventAddInfoAction, aPremiumpploaded, changePlanViewCurrentPlan, onePagePpHoverOnFeatures, packagePickerClickOnCtaInAnonymous, packagePickerComparePlanFeatures, packagePickerShowAllFeatures, packagePickerShowFeature, packagePickerTooltipLinkClick, platformizedPackagePickerSelectCyclePageMobileShowHideFeaturesSrc17Evid2243, platformizedPackagePickerSelectPlanPageClickOnPlanSrc17Evid974, platformizedPackagePickerSelectPlanPagePlanFeaturesModalCloseSrc17Evid2249 } from '@wix/bi-logger-premium-data/v2';
import { BiUtils, CycleUtils, getSearchParams } from '@wix/package-picker-shared';
import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
import { DEFAULT_PURCHASE_CYCLE, DEFAULT_SALE_PURCHASE_CYCLE } from '../../utils/consts';
import React from 'react';
import { useCurrentModule } from '../../components';
import { useBiLogger } from './useBiLogger';
import { useCommonBiEventsFields } from './useCommonBiEventsFields';
import { useInitDowngradeModalBiEvents } from './useInitDowngradeModalBiEvents';
import { useInitGeneralBiEvents } from './useInitGeneralBiEvents';
export const useInitSelectPlanPageBiEvents = () => {
  var _offeringQuery$data;
  const [didInit, setDidInit] = React.useState(false);
  const module = useCurrentModule();
  const {
    setBiEvent
  } = module.SDK;
  const {
    biLogger
  } = useBiLogger();
  useInitGeneralBiEvents();
  useInitDowngradeModalBiEvents();
  const {
    commonBiEventsFields,
    isLoading: isCommonBiEventsFieldsLoading
  } = useCommonBiEventsFields();
  const selectedCycleId = module.SDK.PackagePickerStore.useSelectedCycleId();
  const selectedCycle = CycleUtils.convertCycleIdToCycle(selectedCycleId) || undefined;
  const currencyQuery = module.SDK.eclipseOfferingApiClient.hooks.useFetchCurrency({});
  const offeringQuery = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const hasSale = Boolean((_offeringQuery$data = offeringQuery.data) == null || (_offeringQuery$data = _offeringQuery$data.discountInfo) == null || (_offeringQuery$data = _offeringQuery$data.sale) == null ? void 0 : _offeringQuery$data.saleType);
  const defaultCycle = hasSale ? DEFAULT_SALE_PURCHASE_CYCLE : DEFAULT_PURCHASE_CYCLE;
  const biCycle = BiUtils.getBiCycle(selectedCycle ?? defaultCycle);
  const isLoading = isCommonBiEventsFieldsLoading || currencyQuery.isLoading || offeringQuery.isLoading;
  React.useEffect(() => {
    if (isLoading) {
      return;
    }
    setBiEvent('onSelectPlanPageLoad', () => {
      var _offeringQuery$data2, _currencyQuery$data, _offeringQuery$data3, _offeringQuery$data4;
      const {
        isDowngradeEnabled
      } = getSearchParams();
      const pricing = (_offeringQuery$data2 = offeringQuery.data) == null || (_offeringQuery$data2 = _offeringQuery$data2.products) == null ? void 0 : _offeringQuery$data2.map(product => {
        var _product$pricingDetai, _yearlyCycle$finalPri, _yearlyCycle$savings;
        const yearlyCycle = (_product$pricingDetai = product.pricingDetails) == null ? void 0 : _product$pricingDetai.find(p => CycleUtils.isCycleEqual(p.cycle, {
          cycleDuration: {
            count: 1,
            unit: PurchaseOffering.DurationUnit.YEAR
          },
          cycleType: PurchaseOffering.CycleType.RECURRING
        }));
        return {
          price: yearlyCycle == null || (_yearlyCycle$finalPri = yearlyCycle.finalPrice) == null || (_yearlyCycle$finalPri = _yearlyCycle$finalPri.monthlyTotal) == null ? void 0 : _yearlyCycle$finalPri.formattedAmount,
          subtitle: product.description,
          title: product.name,
          id: product.productId,
          discount: yearlyCycle == null || (_yearlyCycle$savings = yearlyCycle.savings) == null || (_yearlyCycle$savings = _yearlyCycle$savings.fixedAmount) == null ? void 0 : _yearlyCycle$savings.formattedAmount
        };
      });
      const additionalFields = {
        abTesting: `width:${window.screen.width};height:${window.screen.height}; version: v3`,
        viewMode: 'siteLevel',
        pricing: JSON.stringify(pricing),
        currency: (_currencyQuery$data = currencyQuery.data) == null ? void 0 : _currencyQuery$data.currency,
        flowType: isDowngradeEnabled ? 'change_plan' : 'upgrade',
        packageGuid: (_offeringQuery$data3 = offeringQuery.data) == null || (_offeringQuery$data3 = _offeringQuery$data3.currentSubscriptionInfo) == null ? void 0 : _offeringQuery$data3.subscriptionId,
        offeringType: BiUtils.getBiOfferingType((_offeringQuery$data4 = offeringQuery.data) == null || (_offeringQuery$data4 = _offeringQuery$data4.discountInfo) == null || (_offeringQuery$data4 = _offeringQuery$data4.sale) == null ? void 0 : _offeringQuery$data4.saleType)
      };
      biLogger == null || biLogger.report(
      // 17:940
      aPremiumpploaded({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onSelectPlan', _ref => {
      let {
        productId,
        clickType
      } = _ref;
      const additionalFields = {
        productGuid: productId,
        referralAdditionalInfo: 'select-button',
        clickType,
        cycle: biCycle
      };
      biLogger == null || biLogger.report(
      // 17:974
      platformizedPackagePickerSelectPlanPageClickOnPlanSrc17Evid974({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onContinueToSelectCyclePage', _ref2 => {
      let {
        productId,
        clickType
      } = _ref2;
      const additionalFields = {
        abTesting: `width:${window.screen.width};height:${window.screen.height}; version: v3`,
        productGuid: productId,
        referralAdditionalInfo: 'select-button',
        clickType,
        cycle: biCycle
      };
      biLogger == null || biLogger.report(
      // 17:3905
      aPackagePickerEventAddInfoAction({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onFeatureTooltipHover', _ref3 => {
      let {
        featureKey
      } = _ref3;
      const additionalFields = {
        fromStep: 'select_plan',
        featureKey
      };
      biLogger == null || biLogger.report(
      // 17:3910
      onePagePpHoverOnFeatures({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onToggleFeatureGroup', _ref4 => {
      let {
        groupKey,
        action
      } = _ref4;
      const additionalFields = {
        showFeatureType: groupKey,
        clickType: action === 'open' ? 'show' : 'hide'
      };
      biLogger == null || biLogger.report(
      // 17:3918
      packagePickerShowFeature({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onFeatureTooltipLinkClick', _ref5 => {
      let {
        featureKey,
        url
      } = _ref5;
      const additionalFields = {
        featureKey,
        url
      };
      biLogger == null || biLogger.report(
      // 17:3920
      packagePickerTooltipLinkClick({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onComparePlanFeaturesClick', () => {
      biLogger == null || biLogger.report(
      // 17:3922
      packagePickerComparePlanFeatures({
        ...commonBiEventsFields
      }));
    });
    setBiEvent('onAnonymousCtaClick', _ref6 => {
      let {
        targetUrl,
        origin
      } = _ref6;
      const additionalFields = {
        targetUrl,
        ctaName: `eclipse-anonymous-${origin}-cta`
      };
      biLogger == null || biLogger.report(
      // 17:3923
      packagePickerClickOnCtaInAnonymous({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onToggleFeatureList', _ref7 => {
      let {
        productId,
        action
      } = _ref7;
      const additionalFields = {
        productGuid: productId,
        action
      };
      biLogger == null || biLogger.report(
      // 17:2243
      platformizedPackagePickerSelectCyclePageMobileShowHideFeaturesSrc17Evid2243({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onEnterpriseBannerCtaClick', _ref8 => {
      let {
        targetUrl
      } = _ref8;
      const additionalFields = {
        targetUrl,
        ctaName: 'eclipse-enterprise-banner-cta'
      };
      // TODO: add Bi event for enterprise banner cta click
      biLogger == null || biLogger.report(
      // 17:3923
      packagePickerClickOnCtaInAnonymous({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onFeaturesGridCollapsibleClick', _ref9 => {
      let {
        action
      } = _ref9;
      const additionalFields = {
        clickType: action === 'open' ? 'show' : 'hide'
      };
      biLogger == null || biLogger.report(
      // 17:3919
      packagePickerShowAllFeatures({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onPlanFeaturesModalShow', () => {
      biLogger == null || biLogger.report(
      // 17:7503
      changePlanViewCurrentPlan({
        ...commonBiEventsFields
      }));
    });
    setBiEvent('onPlanFeaturesModalClose', () => {
      biLogger == null || biLogger.report(
      // 17:2249
      platformizedPackagePickerSelectPlanPagePlanFeaturesModalCloseSrc17Evid2249({
        ...commonBiEventsFields
      }));
    });
    setDidInit(true);
  }, [setBiEvent, biLogger, isLoading, commonBiEventsFields, offeringQuery.data, currencyQuery.data, biCycle, hasSale]);
  return {
    didInit
  };
};
//# sourceMappingURL=useInitSelectPlanPageBiEvents.js.map